var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getPastShiftParticipantsByShiftIdFunctionDef } from '../../../../backend/features/shift/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import React from 'react';
import useSWR from 'swr';
export const shiftsFetchKey = 'pastShiftParticipantsByIds';
export const usePastShiftParticipantsByShiftId = ({ shiftId, limit, offset }) => {
    const getPastShiftParticipantsByShiftIdPlatformFn = useTypedPlatformFunction(getPastShiftParticipantsByShiftIdFunctionDef);
    const fetchPastShiftParticipantsByIds = (shiftId, limit, offset) => {
        return getPastShiftParticipantsByShiftIdPlatformFn({
            shiftId,
            limit,
            offset,
        }); // TODO: Remove Type Casting after PLAT-2704;
    };
    const { data: participantsData, mutate, isLoading, error, } = useSWR([shiftsFetchKey, shiftId, limit, offset], (_a) => __awaiter(void 0, [_a], void 0, function* ([, paramsShiftId, paramsLimit, paramsOffset]) {
        return fetchPastShiftParticipantsByIds(paramsShiftId, paramsLimit, paramsOffset).catch(handleErrorSnackbar);
    }), defaultFetcherOptions);
    const fetchParticipants = React.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield mutate();
    }), [mutate]);
    return {
        fetchParticipants,
        participants: participantsData === null || participantsData === void 0 ? void 0 : participantsData.data,
        total: participantsData === null || participantsData === void 0 ? void 0 : participantsData.total,
        isLoading,
        error,
    };
};
